const VOLUMES = [5000, 25000, 50000, 100000, 250000, 500000, 1000000, 5000000]

const LABELS = {
  5000: "5k",
  25000: "25k",
  50000: "50k",
  100000: "100k",
  250000: "250k",
  500000: "500k",
  1000000: "1M",
  5000000: "5M"
}

function toggleValue(root, name) {
  return root.querySelector(`[data-learn-${name}][aria-pressed='true']`)?.dataset[`learn${name[0].toUpperCase()}${name.slice(1)}`] === "yes"
}

function volumeOf(root) {
  const index = Number(root.querySelector("[data-learn-volume]")?.value || 0)
  return VOLUMES[index] || VOLUMES[0]
}

function recommendations(volume, steady, platform, mix, ownIp) {
  const shared = volume < 50000 || !steady
  const rows = []
  if (shared || (!mix && !platform && !ownIp)) {
    rows.push({
      title: "Stay on shared IPs.",
      body: "Shared IPs stay warm with traffic from many senders. Dedicated IPs need steady volume. A dedicated IP is $50 a month."
    })
  }
  if (mix) {
    rows.push({
      title: "Add a stream pool.",
      body: "Keep receipts and bulk on separate pools, on separate clusters.",
      header: "X-Capsule-Pool: receipts"
    })
  }
  if (platform && steady && !shared) {
    rows.push({
      title: "Add a tier pool.",
      body: "Several steady customers can share a reputation. Move a noisy one out quickly.",
      header: "X-Capsule-Pool: high-volume"
    })
  }
  if (ownIp) {
    rows.push({
      title: "Add a customer pool.",
      body: "Use the tenant slug as the pool name. That IP still needs the customer's steady daily volume.",
      header: "X-Capsule-Pool: acme-florist"
    })
  }
  return rows
}

function setPressed(buttons, current) {
  buttons.forEach((button) => button.setAttribute("aria-pressed", String(button === current)))
}

function render(root) {
  const volume = volumeOf(root)
  const steady = toggleValue(root, "steady")
  const platform = toggleValue(root, "platform")
  const mix = toggleValue(root, "mix")
  const ownIp = toggleValue(root, "own")
  const label = root.querySelector("[data-learn-volume-label]")
  if (label) label.textContent = LABELS[volume]
  const slider = root.querySelector("[data-learn-volume]")
  if (slider) slider.setAttribute("aria-valuetext", `${LABELS[volume]} messages a month`)
  const recs = recommendations(volume, steady, platform, mix, ownIp)
  const list = root.querySelector("[data-learn-recs]")
  if (list) {
    list.replaceChildren()
    recs.forEach((rec) => {
      const card = document.createElement("div")
      card.className = "rounded-xl bg-surface-overlay px-4 py-3 shadow-mock"
      const title = document.createElement("p")
      title.className = "text-[15px] font-semibold text-ink"
      title.textContent = rec.title
      const body = document.createElement("p")
      body.className = "mt-1 text-[13px] leading-5 text-ink-muted"
      body.textContent = rec.body
      card.append(title, body)
      if (rec.header) {
        const header = document.createElement("p")
        header.className = "mt-2 break-all font-mono text-[12px] text-ink"
        header.textContent = rec.header
        card.append(header)
      }
      list.append(card)
    })
  }
  const ips = root.querySelector("[data-learn-ips]")
  if (ips) ips.hidden = !recs.some((rec) => rec.header)
}

export function mount(root) {
  root.querySelector("[data-learn-volume]")?.addEventListener("input", () => render(root))
  ;["steady", "platform", "mix", "own"].forEach((name) => {
    const buttons = Array.from(root.querySelectorAll(`[data-learn-${name}]`))
    buttons.forEach((button) => {
      button.addEventListener("click", () => {
        setPressed(buttons, button)
        render(root)
      })
    })
  })
  render(root)
}
